import {useCallback} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {ContactPhoneOptIn} from "../typedefs";
import {useSiren} from "../SirenContext";
import {FilterQueryParams} from "../../../components/paginated-selector/filters/types";

export function useGetContactPhoneOptIns() {
    const {clientID} = useSiren();
    return useCallback(async (search: string, page: number, filterParams?: FilterQueryParams): Promise<PaginatedResponseV2<ContactPhoneOptIn> | null> => {
        const {status} = filterParams ?? {};
        const res = await platformAPI.get<PaginatedResponseV2<ContactPhoneOptIn>>("api/contact-phone-opt-ins", {
            params: {
                page, limit: 20, search, active: true,
                ...(clientID ? {clientID} : {}),
                ...(status !== undefined ? {status} : {}),
            },
        });
        return res.data;
    }, [clientID]);
}
